export const SET_LOADING = "SET_LOADING";

export function setLoading(loading) {
    return {
        type: SET_LOADING,
        loading,
    };
}
